import api from '@js/api';

export const ADYEN_GATEWAYS = ['Adyen', 'Adyen_Testing'];

export function isAdyenGateway(gateway) {
	return ADYEN_GATEWAYS.includes(gateway);
}

export function extractAdyenAdditionalDetails(state) {
	const root = state && state.data !== undefined ? state.data : state;
	const detailsFromRoot = root && typeof root === 'object' && 'details' in root
		? root.details
		: root;

	return detailsFromRoot !== undefined
		? detailsFromRoot
		: (state && state.details !== undefined ? state.details : {});
}

export default {
	data() {
		return {
			cardComponent: null,
			checkoutInstance: null,
			adyen3dsActive: false,
			adyen3dsOriginalParent: null,
		};
	},

	methods: {
		buildAdyenThreeDsCardHooks() {
			return {
				onAdditionalDetails: async (state) => {
					await this.submitAdyenThreeDsDetails(extractAdyenAdditionalDetails(state));
				},
				onSubmit: (state, component, actions) => {
					actions.reject();
				},
			};
		},

		ensureAdyen3dsVisible() {
			this.adyen3dsActive = true;

			const container = document.querySelector('#adyen-checkout-container');
			const holder = document.querySelector('#adyen-3ds-challenge-holder');
			if (!container || !holder) {
				return;
			}

			if (!this.adyen3dsOriginalParent) {
				this.adyen3dsOriginalParent = container.parentElement;
			}

			if (!holder.contains(container)) {
				holder.appendChild(container);
			}
		},

		clearAdyen3dsOverlay() {
			this.adyen3dsActive = false;

			const container = document.querySelector('#adyen-checkout-container');
			if (
				container
				&& this.adyen3dsOriginalParent
				&& !this.adyen3dsOriginalParent.contains(container)
			) {
				this.adyen3dsOriginalParent.appendChild(container);
			}
		},

		async handleAdyenThreeDsAction(action) {
			if (!this.cardComponent || typeof this.cardComponent.handleAction !== 'function') {
				throw new Error('Card form is no longer available. Please refresh the page and try again.');
			}

			this.ensureAdyen3dsVisible();
			await this.cardComponent.handleAction(action);
		},

		async submitAdyenThreeDsDetails(details) {
			try {
				const response = await api.submitAdyenPaymentDetails(details);

				if (response.type && response.type === 'error') {
					this.clearAdyen3dsOverlay();
					this.$emit('three-ds-error', {
						message: response.message || 'We could not verify your card. Please try again.',
					});
					return;
				}

				const meta = response.meta;

				if (meta?.payment?.requires_action === true && meta.payment?.action) {
					await this.handleAdyenThreeDsAction(meta.payment.action);
					return;
				}

				if (meta?.next_url) {
					this.clearAdyen3dsOverlay();
					this.$emit('three-ds-complete', { response });
					return;
				}

				this.clearAdyen3dsOverlay();
				this.$emit('three-ds-error', {
					message: 'There was an issue completing your payment.',
				});
			} catch (error) {
				this.clearAdyen3dsOverlay();
				console.error('[Adyen|3DS] submitAdyenThreeDsDetails:', error);
				this.$emit('three-ds-error', {
					message: this.parseThreeDsErrorMessage(error),
				});
			}
		},

		parseThreeDsErrorMessage(error) {
			if (error?.response?.data?.message) {
				return error.response.data.message;
			}

			const responseErrors = error?.response?.data?.errors;
			if (responseErrors && typeof responseErrors === 'object') {
				const firstKey = Object.keys(responseErrors)[0];
				if (firstKey && Array.isArray(responseErrors[firstKey]) && responseErrors[firstKey][0]) {
					return responseErrors[firstKey][0];
				}
			}

			return error?.message || 'We could not verify your card. Please try again.';
		},
	},
};
